export enum EnumEventType {
  STANDARD = 1,
  GMG = 2,
}
